import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import("host/theme");
import("host/utils").catch((err) => {
  console.warn("Failed to preload host/utils:", err);
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



